import { Link, useNavigate } from "react-router-dom";
import { useUnsavedChanges } from "../../context/UnsavedChangesContext";

function isExternalUrl(url) {
    try {
        const parsed = new URL(url);
        return parsed.origin !== window.location.origin;
    } catch (err) {
        return false;
    }
}

export function GuardedLink({ to, state, replace = false, children, onClick, ...rest }) {
    const navigate = useNavigate();
    const { isDirty, setIsDirty } = useUnsavedChanges();

    const handleClick = (e) => {
        if (onClick) onClick(e);
        if (e.defaultPrevented) return;
        e.preventDefault();

        if (isDirty) {
            const confirmLeave = window.confirm("You have unsaved changes. Leave?");
            if (!confirmLeave) return;
        }
        setIsDirty(false);
        const isExternal = typeof to === "string" && isExternalUrl(to);

        if (isExternal) {
            console.log("External navigation to:", to);
            window.open(to, "_blank", "noopener,noreferrer");
        } else {
            console.log("Internal navigation to:", to);
            navigate(to, { state, replace });
        }
    };

    return (
        <Link
            to={typeof to === "string" && isExternalUrl(to) ? "#" : to}
            state={state}
            replace={replace}
            onClick={handleClick}
            {...rest}
        >
            {children}
        </Link>
    );
}
